export const emptyDataGridFilterModel = {
  items: [],
  quickFilterValues: [],
};

const serializeFilterValue = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString();
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => String(item ?? "").trim())
      .filter(Boolean)
      .join(",");
  }

  return String(value);
};

export const areDataGridFilterModelsEqual = (left, right) =>
  JSON.stringify({
    items: left?.items || [],
    quickFilterValues: left?.quickFilterValues || [],
  }) ===
  JSON.stringify({
    items: right?.items || [],
    quickFilterValues: right?.quickFilterValues || [],
  });

export const toServerGridFilterParams = (filterModel) => {
  const search = (filterModel?.quickFilterValues || [])
    .map((value) => String(value ?? "").trim())
    .filter(Boolean)
    .join(" ");

  const columnFilters = (filterModel?.items || [])
    .filter((item) => item?.columnField && item?.operatorValue)
    .map((item) => ({
      field: item.columnField,
      operator: item.operatorValue,
      value: serializeFilterValue(item.value),
    }))
    .filter((item) => {
      const operator = String(item.operator).toLowerCase();
      if (operator === "isempty" || operator === "isnotempty") {
        return true;
      }

      return Boolean(item.value);
    });

  return {
    ...(search ? { search } : {}),
    ...(columnFilters.length > 0 ? { columnFilters: JSON.stringify(columnFilters) } : {}),
  };
};
